import React from "react";
import { InputWithLabel } from "../../components/micro";

const FromSingpass = ({ values }) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <InputWithLabel
        className={"border"}
        idFromName="alias_name"
        label="Alias Name"
        type="text"
        value={values?.alias_name}
      />
      <InputWithLabel
        className={"border"}
        idFromName="country_place_of_birth"
        label="Country/Place of Birth"
        type="text"
        value={values?.country_place_of_birth}
      />
      <InputWithLabel
        className={"border"}
        idFromName="employment_sector"
        label="Employment Sector"
        type="text"
        value={values?.employment_sector}
      />
      <InputWithLabel
        className={"border"}
        idFromName="nric_fin"
        label="NRIC/FIN"
        type="text"
        value={values?.nric_fin}
      />
      <InputWithLabel
        className={"border"}
        idFromName="openid"
        label="OpenID"
        type="text"
        value={values?.openid}
      />

      <InputWithLabel
        className={"border"}
        idFromName="pass_expiry_date"
        label="Pass Expiry Date"
        type="text"
        value={values?.pass_expiry_date}
      />
      <InputWithLabel
        className={"border"}
        idFromName="pass_status"
        label="Pass Status"
        type="text"
        value={values?.pass_status}
      />
      <InputWithLabel
        className={"border"}
        idFromName="pass_type"
        label="Pass Type"
        type="text"
        value={values?.pass_type}
      />
      <InputWithLabel
        className={"border"}
        idFromName="passport_expiry_date"
        label="Passport Expiry Date"
        type="text"
        value={values?.passport_expiry_date}
      />
      <InputWithLabel
        className={"border"}
        idFromName="passport_number"
        label="Passport Number"
        type="text"
        value={values?.passport_number}
      />
      <InputWithLabel
        className={"border"}
        idFromName="principal_name"
        label="Principal Name"
        type="text"
        value={values?.principal_name}
      />
      <InputWithLabel
        className={"border"}
        idFromName="registered_address"
        label="Registered Address"
        type="text"
        value={values?.registered_address}
      />
      <InputWithLabel
        className={"border"}
        idFromName="residential_status"
        label="Residential Status"
        type="text"
        value={values?.residential_status}
      />
      <InputWithLabel
        className={"border"}
        idFromName="sex"
        label="sex"
        type="text"
        value={values?.Sex}
      />
    </div>
  );
};

export default FromSingpass;
